export default function AgendaItemCommentDirective() {
  return {
    template: require('./agendaItem-comment.html'),
    scope: {
      agendaItemId: '=',
      canDelete: '=',
      agendaItemCommentDetail: '=',
      isInDialog: '='
    },
    controller: 'AgendaItemCommentController',
    controllerAs: 'agendaItemCommentVM',
    bindToController: true,
    replace: true
  };
}
